"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeletedSkillProvisionImpulse = void 0;
var TenantKeyOne_1 = require("./TenantKeyOne");
/**
 * Impulse which indicates the result of a delete SkillProvision impulse
 */
var DeletedSkillProvisionImpulse = /** @class */ (function (_super) {
    __extends(DeletedSkillProvisionImpulse, _super);
    function DeletedSkillProvisionImpulse() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "DeletedSkillProvisionImpulse";
        _this.id = function () {
            _this.push(function (_) { return "id"; });
        };
        _this.data = function (config) { return _this.push(function (registry) {
            var entity = new TenantKeyOne_1.TenantKeyOne();
            config(entity);
            return "data { " + entity.render(registry) + " }";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return DeletedSkillProvisionImpulse;
}(Array));
exports.DeletedSkillProvisionImpulse = DeletedSkillProvisionImpulse;
//# sourceMappingURL=DeletedSkillProvisionImpulse.js.map